export const EInvoicingNetworks = {
  PDP: 'PDP',
  NEMHANDEL: 'NEMHANDEL',
} as const

export type EInvoicingNetworkKeys = (typeof EInvoicingNetworks)[keyof typeof EInvoicingNetworks]
